import { FC } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import { Box, Link, Typography } from '@mui/material';
import { ISignIn } from 'types/Auth';

export const CreateAccountLink: FC = () => {
  const { userRole } = useParams<{ userRole: ISignIn['role'] }>();

  const { push } = useHistory();

  const handleLogin = () => { 
    if (userRole === 'tutor') {
      push(`/${userRole}/registration/mensal`);
    } else {
      push(`/${userRole}/registration`);
    }
  };

  return (
    <Box sx={{ display: 'flex' }} justifyContent="center">
      <Typography variant="body2" sx={{ color: '#757575' }}>
        Não tem uma conta?&nbsp;
      </Typography>

      <Link
        variant="body2"
        underline="none"
        onClick={handleLogin}
        sx={{ cursor: 'pointer' }}
      >
        CADASTRE-SE
      </Link>
    </Box>
  );
};
